var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCluster({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#CBD5DC",
    cx: 150,
    cy: 150,
    r: 150
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.91, 149.9) rotate(-5) translate(-149.91, -149.9)translate(60, 60)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.140013,164.34242 L139.129663,126.332587 C135.238987,122.456566 128.946429,122.456566 125.055754,126.332587 C104.456472,146.249747 73.0058346,149.744128 48.5369355,134.834351 C24.0680365,119.924575 12.7544031,90.372392 21.0110746,62.9344369 C29.267746,35.4964818 55.0115558,17.0953779 83.6452882,18.1648911 C112.279021,19.2344043 136.578356,39.5046953 142.765122,67.4821347 C144.920691,77.351058 144.698615,87.5910923 142.117218,97.3572876 C141.287771,100.469281 142.181581,103.78738 144.461959,106.061689 C146.742337,108.335998 150.062839,109.220996 153.172664,108.383312 C156.28249,107.545628 158.709182,105.112527 159.538629,102.000534 C169.78263,63.4994818 150.555195,23.2576818 114.165513,7.03748316 C77.7758306,-9.18271543 34.9934561,3.41906791 13.2071854,36.7753129 C-8.57908532,70.1315578 -2.92158824,114.370458 26.5578105,141.170765 C56.0372091,167.971072 100.614058,169.401215 131.750759,144.545632 L164.397907,177.156341 C166.086133,178.848817 168.378425,179.8 170.76896,179.8 C173.159496,179.8 175.451788,178.848817 177.140013,177.156341 C178.854691,175.465337 179.82,173.157602 179.82,170.74938 C179.82,168.341158 178.854691,166.033424 177.140013,164.34242 L177.140013,164.34242 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.246252,108.155536 C105.289041,105.408235 100.848094,105.008555 97.4478572,107.183693 C87.9438583,113.047946 76.0033174,113.282342 66.2764899,107.795594 C62.9509822,105.855092 58.7443162,106.338778 55.9460252,108.983401 L55.4061055,109.48732 C53.4466274,111.354082 52.4706805,114.028389 52.7672244,116.718429 C53.0637682,119.408468 54.5988205,121.805976 56.9178808,123.201095 C72.6007438,132.243057 92.0016085,131.855045 107.310391,122.193258 C109.533478,120.780831 110.99445,118.434905 111.281467,115.816786 C111.568484,113.198666 110.650457,110.591944 108.786172,108.731442 L108.246252,108.155536 Z",
    fill: "#2E8F79"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCluster);
export default __webpack_public_path__ + "static/media/no-cluster.5480f784343941a272cfb31982c0ff11.svg";
export { ForwardRef as ReactComponent };